import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class SalaryZoomChart extends Component {
  static propTypes = {
    chartData: PropTypes.any.isRequired,
    chartLineName: PropTypes.string.isRequired,
    height: PropTypes.number,
    onClick: PropTypes.func,
  }
  static defaultProps = {
    height: 350,
  }

  constructor(props) {
    super(props)

    this.constructChart = () => {
      const { chartData, chartLineName, height } = this.props
      return new window.FacetChart({
        container: document.getElementById('salaryZoomChart'),
        toolbar: {
          export: false,
          logScale: false,
          back: false
        },
        area: {
          height,
          style: {}
        },
        data: {
          preloaded: chartData,
          //sortField: 'value'
        },
        facetAxis: {
          defaultUnitWidth: 100,
          labels: {
            textStyle: {
              font: "12px Open Sans"
            }
          }
        },
        events: {
          onClick: this.props.onClick
        },
        legend: {
          enabled: false,
          numberOfColumns: 2,
          lineSpacing: 0.1,
          padding: 2,
          margin: 2,
          text: {
            font: '12px Open Sans'
          },
          panel: {
            align: "right",
            location: "inside",
            side: "top",
          }
        },
        series: [
          ...(chartLineName === 'mean_salary' ? [
            {
              data: {
                field: 'perc_75'
              },
              id: 's1',
              name: '75th Percentile',
              type: 'line',
              stack: "1",
              style: {
                fillColor: '#add8e6a3',
                // shadowColor: 'rgba(0,0,0,0.5)',
                lineWidth: 0,
                smoothing: true,
                lineColor: 'green',
                marker: {
                  shape: 'circle',
                  width: 0,
                  lineColor: 'red'
                },
              }
            },
            {
              data: {
                field: 'perc_25'
              },
              id: 's2',
              name: '25th Percentile',
              type: 'line',
              stack: "2",
              style: {
                fillColor: 'white',
                lineWidth: 0,
                smoothing: true,
                lineColor: 'red',
                marker: {
                  shape: 'circle',
                  width: 0,
                  fillColor: 'white',
                  lineColor: '#003F87'
                }
              }
            }
          ] : []),
          {
            data: {
              field: chartLineName === 'mean_salary' ? 'perc_50' : chartLineName,
            },
            id: 's3',
            name: 'Average Salary',
            // type: 'line',
            type: 'line',
            stack: "3",

            style: {
              ...(chartLineName === 'salary' ? { fillColor: '#add8e6a3' } : {}),
              // shadowColor: 'rgba(0,0,0,0.5)',
              lineWidth: 6,
              smoothing: true,
              lineColor: '#003F87',
              marker: {
                shape: 'circle',
                width: 12,
                fillColor: 'white',
                lineColor: '#003F87'
              }
            }
          },
        ]
      })
    }

  }

  componentDidMount() {
    setTimeout(() => {
      this.constructChart()
    }, 100)
  }

  componentDidUpdate(nextProps) {
    if(nextProps.chartData !== this.props.chartData) {
      setTimeout(() => {
        this.constructChart()
      }, 100)
    }
  }

  render() {
    return(
      <div>
        <div id="salaryZoomChart"/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/components/SalaryZoomChart.js